import { render, staticRenderFns } from "./Avatart.vue?vue&type=template&id=f5d3e064&"
import script from "./Avatart.vue?vue&type=script&lang=ts&"
export * from "./Avatart.vue?vue&type=script&lang=ts&"
import style0 from "./Avatart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
